import { render } from "./TipsModal.vue?vue&type=template&id=54252ac9&scoped=true"
import script from "./TipsModal.vue?vue&type=script&lang=js"
export * from "./TipsModal.vue?vue&type=script&lang=js"

import "./TipsModal.vue?vue&type=style&index=0&id=54252ac9&lang=css"
import "./TipsModal.vue?vue&type=style&index=1&id=54252ac9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54252ac9"

export default script